import { Component, inject, Input } from '@angular/core';
import { DeleteMaintenanceRecordService } from '../services/delete-maintenance-record.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MaintenanceRecordWithDueDate } from "../../../../../models/MaintenanceRecordWithDueDate";

@Component({
  selector: 'app-delete-maintenance-modal',
  templateUrl: './delete-maintenance-modal.component.html',
  styleUrl: './delete-maintenance-modal.component.scss'
})
export class DeleteMaintenanceModalComponent {
  @Input() maintenance!: MaintenanceRecordWithDueDate;

  isDeleting = false;
  hasError = false;
  
  deleteMaintenanceRecordService = inject(DeleteMaintenanceRecordService);
  activeModal = inject(NgbActiveModal);
  
  deleteMaintenanceRecord() {
    this.isDeleting = true;
    this.hasError = false;
    
    this.deleteMaintenanceRecordService.deleteMaintenance(this.maintenance.maintenanceId).subscribe({
      next: () => {
        this.activeModal.close(true);
      },
      error: () => {
        this.isDeleting = false;
        this.hasError = true;
      }
    })
  }

  closeModal() {
    this.activeModal.dismiss();
  }
}
